import React from 'react'
import { colors } from 'pixel-base'
import styled, { css } from 'styled-components'

type HeaderProps = {
  onSearchClick: () => void
  onProfileClick: () => void
  title: string
  image: string
  subTitle: string
}

export default function Header(props: HeaderProps) {
  const { title, onProfileClick, onSearchClick } = props
  const imag =
    'data:image/jpeg;base64,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'
  return (
    <Container
      style={{
        background: colors.grayLighter,
        borderBottom: `1px solid ${colors.grayBorderLight}`,
      }}
    >
      <AvatarWrapper>
        <Avatar src={imag} />
      </AvatarWrapper>
      <ProfileWrapper onClick={onProfileClick}>
        <Name>{title}</Name>
        {/* {subTitle && <Subtitle>{subTitle}</Subtitle>} */}
      </ProfileWrapper>
      <Actions>
        <Action
          style={{ background: 'transparent', border: 'none' }}
          onClick={onSearchClick}
        >
          {/* <Icon
            style={{ color: 'rgb(145, 145, 145)' }}
            id="search"
            className="icon search-icon"
          /> */}
        </Action>
      </Actions>
    </Container>
  )
}

const Container = styled.div`
  /* should refactor to header  */
  /* background: 'rgb(237, 237, 237)'; */
  background-color: ${colors.grayLighter};
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 60px;
  padding: 10px;
  min-height: 60px;
  border-bottom: 1px solid ${colors.grayBorderLight};
  /* should refactor to header  */

  z-index: 10;

  .icon {
    color: ${colors.grayText};
  }

  .search-icon {
    width: 30px;
    height: 30px;
  }
`

const AvatarWrapper = styled.div`
  width: 40px;
  height: 40px;
  margin-right: 10px;
  cursor: pointer;
`

const Avatar = styled.img`
  /* should refactor to avatar */
  border-radius: 50%;
  height: 100%;
  width: 100%;
  object-fit: cover;
  /* should refactor to avatar */
`

const ProfileWrapper = styled.div<{ onClick: any }>`
  flex: 1;
  cursor: pointer;
`

const profileStyles = css`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`

const Name = styled.h2`
  color: ${colors.black};
  font-size: 1rem;
  margin-bottom: 2px;

  ${profileStyles}
`

const Actions = styled.div`
  margin-right: 20px;
  display: flex;
  align-items: center;

  .action-menus-wrapper {
    z-index: 20;
  }
`

const actionStyles = css`
  margin-left: 25px;
  cursor: pointer;
`

const Action = styled.button`
  ${actionStyles}
`
